import React from 'react'
import { Link } from '../base-ui'
import { Divider } from 'antd';
import { css } from '@emotion/react'
import { MediaQuery } from '../base-ui/Utility';

function HeaderTopBar() {
    const topBarStyle = css`
        display: flex; 
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        background-color: #ffffff;
        .left-items ul li {
            display: inline-block;
            margin: 0 0.5rem;
            font-size: 1rem;
        }
        padding: 0.5rem 1rem;
        ${MediaQuery('lg', 'min')} {
            padding: 0.5rem 5rem;
        } 
        ${MediaQuery('xl', 'min')} {
            padding: 0.5rem 10rem;
        }
        ${MediaQuery('xxl', 'min')} {
            padding: 0.5rem 20rem;
        }
    `

    return (
        <div css={topBarStyle} className="top-bar">
            <div className="left-items">
                <ul>
                    <li><Link href="/">About Us</Link></li>
                    <Divider type="vertical" />
                    <li><Link href="/">Refund Policy</Link></li>
                    <Divider type="vertical" />
                    <li><Link href="/">Help Desk</Link></li>
                </ul>
            </div>
            <div className="right-items"><Link href="/">GET A QUOTE</Link></div>
        </div>
    )
}

export default HeaderTopBar